import {
	JobApplicationAssessmentState,
	JobApplicationCompanyReviewState,
	JobApplicationInterviewState,
	JobApplicationOfferState,
	JobApplicationReviewState,
	JobApplicationStep,
	StepPriority
} from '../types/job-application';

export const createStepsStatus = (initialStep: JobApplicationStep = JobApplicationStep.APPLICATION_REVIEW) => {
	return {
		application_review:
			StepPriority[initialStep] > StepPriority[JobApplicationStep.APPLICATION_REVIEW]
				? JobApplicationReviewState.PASSED
				: JobApplicationReviewState.REVIEWING,
		assessment:
			StepPriority[initialStep] > StepPriority[JobApplicationStep.ASSESSMENT]
				? JobApplicationAssessmentState.PASSED
				: initialStep === JobApplicationStep.ASSESSMENT
				? JobApplicationAssessmentState.PENDING
				: undefined,
		company_review:
			StepPriority[initialStep] > StepPriority[JobApplicationStep.COMPANY_REVIEW]
				? JobApplicationCompanyReviewState.PASSED
				: initialStep === JobApplicationStep.COMPANY_REVIEW
				? JobApplicationCompanyReviewState.REVIEWING
				: undefined,
		interview:
			StepPriority[initialStep] > StepPriority[JobApplicationStep.INTERVIEW]
				? JobApplicationInterviewState.PASSED
				: initialStep === JobApplicationStep.INTERVIEW
				? JobApplicationInterviewState.WAITING
				: undefined,
		offer: initialStep === JobApplicationStep.OFFER ? JobApplicationOfferState.PENDING : undefined
	};
};
